module.exports = __webpack_public_path__ + "8d751e45830960f0051dbc28ab509053.woff2";